import { privateApi } from 'api';
import { createQuery } from 'react-query-kit';


export type GetDiscountsParams = unknown

export type Discount = {
    tenant_id: string;
    id: string;
    name: string;
    default_type: 'fixed' | 'percentage';
    default_amount: number;
    deleted: boolean;
}

export type GetDiscountsResult = Discount[];

async function getDiscounts(): Promise<GetDiscountsResult> {

    // make api call
    const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/finance/discounts`);

    // return the data object
    return result.data as GetDiscountsResult;
}

const useGetDiscounts = createQuery<GetDiscountsResult, GetDiscountsParams, Error>({
    queryKey: ['discounts'],
    fetcher: () => getDiscounts(),
})

export { useGetDiscounts };

